import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpsertSeasonEntityModel } from "~pages/SeasonEntities/types/upsertSeasonEntityModel";
import type { SeasonEntityResponse } from "~types/seasonEntity.ts";

export const useUpsertSeasonEntity = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<SeasonEntityResponse, Error, UpsertSeasonEntityModel>({
    mutationFn: async ({ entityId, ...upsertData }) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities?include=seasons,entities,conferences,divisions`, {
        method: "POST",
        body: {
          entityId,
          ...upsertData,
        },
      }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["seasonEntities", sport, organizationId, seasonId] }),
        queryClient.invalidateQueries({ queryKey: ["seasonEntity", sport, organizationId, seasonId] }),
      ]);
    },
  });
};
